(ns frontend.view.modals.components.error-layer
  (:require [frontend.utils :as fu]
            [common.localization :as loc]))

(defn generic-error [data-state]
  [:div
   (loc/tr :unknown-error-message-pre)
   [:a {:href "mailto:support@zapflow.com"}
    "support@zapflow.com"]
   (loc/tr :unknown-error-message-post)])

(defn error-response [error-response]
  [:div
   {:class "flex gap-2 items-center"}
   (:message error-response)
   [:a {:href "mailto:support@zapflow.com"}
    "support@zapflow.com"]
   (loc/tr :unknown-error-message-post)])
